export default function nmaExternalHash(isNativeMobileApplication) {
    if (isNativeMobileApplication) {
        return '#external';
    }

    return '';
}
